/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_Start_SuccessInputs */



/**
* | output |
* | --- |
* | "Snap to event start finished successfully" |
*
* @param {Snap_To_Event_Start_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start_success = /** @type {((inputs?: Snap_To_Event_Start_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Start_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement sur le début des événements terminé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snap zum Ereignisstart erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancio all'inizio dell'evento completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снимок экрана для начала события успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar al inicio del evento finalizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照到事件开始已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント開始へのスナップが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप टू इवेंट सफलतापूर्वक शुरू हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento Snap to event start foi concluído com sucesso.")
	return /** @type {LocalizedString} */ ("Snap to event start finished successfully")
});